import styled from 'styled-components';

const Btn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 8px;
  font-size: 12.5px;
  font-weight: 600;
  letter-spacing: 0.01em;
  border: 1px solid transparent;
  cursor: pointer;
  font-family: 'Inter', -apple-system, system-ui, sans-serif;
  transition: all 0.2s cubic-bezier(0.22, 1, 0.36, 1);

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const ApproveBtn = styled(Btn)`
  background: var(--success-color);
  color: #fff;
  min-width: 110px;
  box-shadow: 0 2px 6px rgba(56, 161, 105, 0.15);

  &:hover:not(:disabled) {
    background: var(--success-dark);
    box-shadow: 0 4px 12px rgba(56, 161, 105, 0.25);
    transform: translateY(-1px);
  }
`;

const TypeChip = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 3px 9px;
  border-radius: 999px;
  font-size: 10.5px;
  font-weight: 500;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  background: var(--background-secondary);
  color: var(--text-muted);
  border: 1px solid var(--border-color);
`;

const ErrMsg = styled.div`
  margin-top: 12px;
  padding: 12px 13px;
  background: rgba(229, 62, 62, 0.08);
  border: 1px solid var(--error-light);
  border-radius: 8px;
  color: var(--error-color);
  font-size: 13px;
  font-weight: 500;
`;


export {
  Btn, ApproveBtn, TypeChip, ErrMsg,
};
